import { forwardRef } from 'react';

import { cn } from '@/utils';

const CalendarItemSkeleton = forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => {
  return (
    <div
      className={cn(
        'bg-cold-lips-light-cardbg flex flex-col gap-2.5 items-start justify-start p-6 rounded-2xl w-full animate-pulse',
        className
      )}
      ref={ref}
      {...props}
    >
      <div className="flex flex-wrap gap-4 items-center justify-between w-full">
        <div className="flex-5 flex gap-6 items-center justify-start">
          {/* Icon skeleton */}
          <div className="bg-white box-border flex gap-2.5 items-center justify-start p-2 rounded-xl shrink-0">
            <div className="bg-white rounded h-6 w-6" />
          </div>
          {/* Title skeleton */}
          <div className="bg-white rounded-full h-6 w-42" />
        </div>
        <div className="flex-2 flex items-center justify-end">
          {/* Status pill skeleton */}
          <div className="bg-white rounded-full h-8 w-24" />
        </div>
        <div className="flex-3 flex gap-3 items-center justify-end md:flex-initial md:w-auto w-full md:justify-end justify-center">
          {/* Date/time skeleton */}
          <div className="bg-white box-border flex items-center justify-between w-full px-6 py-2 rounded-2xl">
            <div className="bg-white rounded-full h-6 w-40" />
          </div>
        </div>
      </div>
    </div>
  );
});

CalendarItemSkeleton.displayName = 'CalendarItemSkeleton';

export { CalendarItemSkeleton };
